module.exports = __webpack_public_path__ + "static/media/award-3.332b3801.png";